module.exports = __webpack_public_path__ + "wdl_logo.webp";